import { isAfter, isPast } from 'date-fns';

export const hasNodeOverdue = (dueDate?: string | Date, end?: string | Date) => {
  if (dueDate && end) {
    return isAfter(new Date(end), new Date(dueDate));
  }
  return !!(dueDate && isPast(new Date(dueDate)));
};
